export default __webpack_public_path__ + "static/media/bike-active.b0d16d8b.svg";